import React, { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import BentoIcon from './BentoIcon';
import ActionNotification from './ActionNotification';

const variantIcon: Record<'success' | 'warning' | 'error' | 'info', string> = {
  success: 'circle-check',
  warning: 'triangle-exclamation',
  error: 'circle-exclamation',
  info: 'circle-info',
};

interface NotificationWrapperProps {
  message: ReactNode;
  onClose: () => void;
  variant: 'error' | 'info' | 'success' | 'warning';
  withAction?: boolean;
  [key: string]: any;
}

function NotificationWrapper({
  message,
  onClose,
  variant,
  withAction,
  ...other
}: NotificationWrapperProps) {
  const variantStyles = {
    success: {
      backgroundColor: '#CCF2CC',
      color: '#00A757',
      borderBottom: '4px solid #00A757',
    },
    error: {
      backgroundColor: '#FFE6E6',
      color: '#ec0000',
      borderBottom: '4px solid #ff9595',
    },
    info: {
      backgroundColor: '#b0e7ff',
      color: '#1d3362',
      borderBottom: '4px solid #5aceff',
    },
    warning: {
      backgroundColor: ' #ffeddd',
      color: '#de6a00',
      borderBottom: '4px solid #f7af6c',
    },
  };

  const iconName = variantIcon[variant];

  return (
    <Alert
      aria-describedby="client-alert"
      icon={<BentoIcon name={iconName} sx={{ fontSize: 20, opacity: 0.9, marginRight: 1 }} />}
      action={[
        withAction ? (
          <ActionNotification />
        ) : (
          <IconButton key="close" aria-label="close" color="inherit" onClick={onClose} size="large">
            <BentoIcon name="xmark" variant="regular" sx={{ fontSize: 20 }} />
          </IconButton>
        ),
      ]}
      severity={variant}
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...variantStyles[variant],
      }}
      {...other}
    >
      {message}
    </Alert>
  );
}

export default NotificationWrapper;
